"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function OrderLookupPage() {
  const router = useRouter();
  const [orderNumber, setOrderNumber] = useState("");

  function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    const normalized = orderNumber.trim().toUpperCase();
    if (normalized) router.push(`/order-confirmation/${normalized}`);
  }

  return (
    <main className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-6 py-16">
      <Card>
        <CardHeader>
          <h1 className="font-heading text-2xl font-bold">Find Your Order</h1>
          <p className="text-sm text-muted-foreground">
            Enter the order number from your confirmation, like ABCD-1234.
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="orderNumber">Order number</Label>
              <Input
                id="orderNumber"
                placeholder="ABCD-1234"
                value={orderNumber}
                onChange={(event) => setOrderNumber(event.target.value)}
                className="uppercase"
              />
            </div>
            <Button type="submit" className="w-full">
              Look Up Order
            </Button>
          </form>
        </CardContent>
      </Card>
    </main>
  );
}
